// extracted by mini-css-extract-plugin
export default {"clickableTextPanelContainer":"FixedClickableTextPanel_clickableTextPanelContainer__7hHGJ","hidden":"FixedClickableTextPanel_hidden__QOfPL"};